<template>
  <el-row :gutter="0" style="display: flex">
    <el-col
      ><div class="grid-content">
        <pei-zai :waybillSplitId="waybillSplitId"></pei-zai></div
    ></el-col>
    <el-col
      ><div class="grid-content">
        <zhong-zhuan :waybillSplitId="waybillSplitId"></zhong-zhuan></div
    ></el-col>
    <el-col
      ><div class="grid-content">
        <song-huo :waybillSplitId="waybillSplitId"></song-huo></div
    ></el-col>
    <el-col
      ><div class="grid-content">
        <qian-shou :waybillSplitId="waybillSplitId"></qian-shou></div
    ></el-col>
    <el-col
      ><div class="grid-content">
        <hui-dan :waybillSplitId="waybillSplitId"></hui-dan></div
    ></el-col>
  </el-row>
</template>

<script>
import PeiZai from "./other/PeiZai.vue";
import HuiDan from "./other/HuiDan.vue";
import QianShou from "./other/QianShou.vue";
import SongHuo from "./other/SongHuo.vue";
import ZhongZhuan from "./other/ZhongZhuan.vue";
export default {
  props: {
    waybillSplitId: {},
  },
  components: {
    PeiZai,
    HuiDan,
    QianShou,
    SongHuo,
    ZhongZhuan,
  },
};
</script>

<style lang="less" scoped >
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
/deep/ .bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #f9fafc;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.grid-content {
  border-width: 1px;
  border-style: solid;
  border-color: #d3dce6;
  border-top-width: 0;
  border-left-width: 0;
  height: 100%;
}
/deep/ .el-form {
  //border: 1px gray solid;
  padding: 5px;
  .el-form-item{
    border-width: 0px;
    border-style: solid;
    border-color: #d3dce6;
    border-bottom-width: 1px;
    
  }
}
</style>